import React from 'react';
import { injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { ActionButton } from 'components/ui/Button';

const NewSearchButton = ({ intl: { formatMessage }, onClick, isSubscription }) => (
  <ActionButton
    data-cy="booking-path-new-search"
    label={formatMessage({ id: isSubscription ? 'subscriptions.abandonSubscriptionPass' : 'searchResults.newSearch' })}
    onClick={onClick}
  />
);

NewSearchButton.propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired
  }).isRequired,
  onClick: PropTypes.func,
  isSubscription: PropTypes.bool
};
export default injectIntl(NewSearchButton);
